var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("preloader", { attrs: { loadData: _vm.loadData, loadCount: 2 } }, [
    _c("div", { staticClass: "main__fixed" }),
    _c("div", { staticClass: "main__popups" }),
    _c("div", { staticClass: "main__collages" }, [
      _c("div", { staticClass: "collages__top" }, [
        _c("img", { attrs: { src: "/img/rating_top.png" } })
      ]),
      _c("div", {
        staticClass: "collages__title",
        domProps: { innerHTML: _vm._s(_vm.data.collage_title) }
      }),
      _c(
        "div",
        { staticClass: "collages__intro" },
        [
          _c("div", { staticClass: "intro__add add_1" }, [
            _c("img", { attrs: { src: "/img/rating_left.png" } })
          ]),
          _c("div", { staticClass: "intro__add add_2" }, [
            _c("img", { attrs: { src: "/img/rating_right.png" } })
          ]),
          _c(
            "div",
            { staticClass: "intro__items" },
            _vm._l(_vm.data.intro.items, function(item, i) {
              return _c("div", { key: i, staticClass: "items__item" }, [
                _c("div", {
                  staticClass: "item__number",
                  domProps: { innerHTML: _vm._s("Шаг " + (i + 1)) }
                }),
                _c("div", {
                  staticClass: "item__text",
                  domProps: { innerHTML: _vm._s(item) }
                })
              ])
            }),
            0
          ),
          _c(
            "linker",
            _vm._b(
              { staticClass: "intro__rules" },
              "linker",
              _vm.data.intro.rules,
              false
            )
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "collages__collages" },
        _vm._l(_vm.data.collages, function(collage, key) {
          return _c("div", { key: key, staticClass: "collages__collage" }, [
            _c("div", {
              staticClass: "collage__image",
              style: _vm.bgi("/collages/" + collage.id + ".jpg")
            }),
            _c("div", { staticClass: "collage__info" }, [
              _c("div", {
                staticClass: "info__name",
                domProps: { innerHTML: _vm._s(collage.name) }
              }),
              _c("div", {
                staticClass: "info__balls",
                domProps: { innerHTML: _vm._s("Баллы: " + collage.scores) }
              })
            ])
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }